import Peerconfiguration from "../../Components/Charging/Peerconfiguration";


export default function Peerconfigurations(){
    return(
        <Peerconfiguration/>
    )
}